export default function LoadingState() {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="text-center">
        <span className="w-9 h-9 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-loader-4-line text-lg animate-spin" aria-hidden="true"></i>
        </span>
        <p className="mt-2 text-sm text-foreground-500">Yükleniyor...</p>
      </div>
    </div>
  );
}